import { RoleSpecialtyOption } from 'shared/components';
import { Role, SpecialtyToRolesMapEntry } from 'shared/types';

// The candidate profile GET delivers the flat (role, speciality) pairs directly
// (`roleSpecialtyPairs`), so no grouped→flat read adapter is needed. The helpers
// below convert the selector's flat value back into the PUT payload, which is
// asymmetric: a flat `roleIds` list plus a grouped `specialtyToRolesMap`.

export function rolesFromRoleSpecialties(
    roleSpecialties: RoleSpecialtyOption[]
): Role[] {
    const roles: Role[] = [];

    for (const pair of roleSpecialties) {
        if (pair.role) {
            // Preserve duplicates and order: roleIds is a multiset, the same role
            // id may legitimately appear in multiple pairs (one slot per occurrence).
            roles.push(pair.role);
        }
    }

    return roles;
}

export function specialtyToRolesMapFromRoleSpecialties(
    roleSpecialties: RoleSpecialtyOption[]
): Pick<SpecialtyToRolesMapEntry, 'specialtyId' | 'roleIds'>[] {
    const bySpecialty = new Map<string, string[]>();

    for (const pair of roleSpecialties) {
        if (!pair.specialty) { continue; }

        const key = pair.specialty.id;
        let roleIds = bySpecialty.get(key);

        if (!roleIds) {
            roleIds = [];
            bySpecialty.set(key, roleIds);
        }

        if (pair.role) {
            // Preserve duplicates: a specialty may be linked to the same role id
            // more than once when that id occurs repeatedly in the roles multiset.
            roleIds.push(pair.role.id);
        }
    }

    return Array.from(bySpecialty.entries()).map(([ specialtyId, roleIds ]) => ({
        specialtyId,
        roleIds
    }));
}
